import clsx from 'clsx'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import Delete from '@/assets/img/delete-icon.svg?react'
import DotsSvg from '@/assets/img/dots.svg'
import Edit from '@/assets/img/edit-pan.svg?react'
import AddIcon from '@/assets/img/ico-add.svg?react'
import Dropdown from '@/compoments/common/Dropdown'
import Pagination from '@/compoments/common/Pagination'
import { PillStatus } from '@/compoments/common/PillStatus'
import SelectBox from '@/compoments/common/SelectBox'
import AddServiseModal from '@/compoments/modals/AddServiseModal'
import PageLoader from '@/compoments/PageLoader'
import {
    useDeleteServiceMutation,
    useGetServicesListQuery,
} from '@/services/tenant/webPage'
import DropdownList from '@/compoments/DropdownList'
import { optionsSepviseStatus } from '@/utils/selectsOptionsConst'

export const AdminServiceManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const queryString = searchParams.toString()
    const [addServiseModal, setAddServiseModal] = useState<boolean>(false)
    const { data, isLoading } = useGetServicesListQuery(queryString)
    const [deleteService] = useDeleteServiceMutation()
    const pageData = data?.data
    const [editUserId, setEditUserId] = useState<string | null>(null)
    const editHandler = (id: number) => {
        setEditUserId(String(id))
        setAddServiseModal(true)
    }
    const deleteHandler = async (id: number) => {
        const { toast } = await import('react-toastify')
        try {
            const res = await deleteService(id).unwrap()
            if (res?.success) {
                toast.success('Deleted successfully!')
            } else {
                toast.error(res?.message || 'Something went wrong')
            }
        } catch (error) {
            console.error('rejected', error)
        }
    }

    const filterHandler = (
        name: string,
        value: string | number | undefined,
    ) => {
        setSearchParams((prev: URLSearchParams) => {
            prev.set('page', '1')
            if (value) {
                prev.set(name, String(value))
            } else {
                prev.delete(name)
            }
            return prev
        })
    }
    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group">
                    <div className="table-header flex items-center justify-between">
                        <div className="table-tools">
                            <SelectBox
                                options={optionsSepviseStatus}
                                placeholder={'Status'}
                                onChange={(option) =>
                                    filterHandler('status', option?.value)
                                }
                                isClearable={true}
                            />
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                setAddServiseModal(true)
                            }}
                            className="btn btn--primary-gradient btn--sm fullRadius"
                        >
                            <AddIcon />
                            <span className="text--xs">Create Service</span>
                        </button>
                    </div>

                    <div className="table-body table-responsive p-0">
                        {isLoading ? (
                            <PageLoader className="h-4/5" />
                        ) : (
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Service Name</th>
                                        <th>Category</th>
                                        <th>Price</th>
                                        <th>Status</th>
                                        <th style={{ width: '10px' }}>
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageData && pageData.length > 0 ? (
                                        pageData.map((servise, index) => (
                                            <tr key={index}>
                                                <td>{servise.name}</td>
                                                <td>{servise.category.name}</td>
                                                <td>${servise.price}</td>
                                                <td>
                                                    <PillStatus
                                                        status={servise.status}
                                                    />
                                                </td>
                                                <td className="text-right sticky-end">
                                                    <Dropdown
                                                        closeSelf={true}
                                                        dropdownClasses="flex flex-col"
                                                        button={
                                                            <span className="ico">
                                                                <img
                                                                    src={
                                                                        DotsSvg
                                                                    }
                                                                    alt=""
                                                                />
                                                            </span>
                                                        }
                                                        menuClassName="dropdown-md"
                                                        menu={
                                                            <DropdownList
                                                                list={[
                                                                    {
                                                                        title: 'Edit',
                                                                        icon: (
                                                                            <Edit />
                                                                        ),
                                                                        action: () =>
                                                                            editHandler(
                                                                                servise.id,
                                                                            ),
                                                                    },
                                                                    {
                                                                        title: 'Delete',
                                                                        icon: (
                                                                            <Delete />
                                                                        ),
                                                                        action: async () =>
                                                                            deleteHandler(
                                                                                servise.id,
                                                                            ),
                                                                        type: 'btn-drp-link-danger',
                                                                    },
                                                                ]}
                                                            />
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5}>
                                                <h4 className="text-center">
                                                    Servises not found
                                                </h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <Pagination
                    pagination={data?.pagination}
                    onPageChange={() => {}}
                />
            </div>
            {addServiseModal && (
                <AddServiseModal
                    isOpen={addServiseModal}
                    onClose={() => {
                        setAddServiseModal(false)
                        setEditUserId(null)
                    }}
                    id={editUserId}
                />
            )}
        </main>
    )
}
